export function getRedsysFormPage(params: { url: string, signatureVersion: string, parameters: string, signature: string }) {
  const pageContent = `<html><head></head><body><div></div><form id="redsysForm" action="${params.url}" method="post">
  <input type="hidden" name="Ds_SignatureVersion" value="${params.signatureVersion}">
  <input type="hidden" name="Ds_MerchantParameters" value="${params.parameters}">
  <input type="hidden" name="Ds_Signature" value="${params.signature}">
  </form> <script type="text/javascript">document.getElementById("redsysForm").submit();</script></body></html>`;
  return 'data:text/html;base64,' + btoa(pageContent);
}
